'use client';
import { createProps, createSplitProps } from '@chakra-ui/utils';

const radioGroupProps = createProps()([
  "defaultValue",
  "isDisabled",
  "isFocusable",
  "isNative",
  "name",
  "onChange",
  "value"
]);
const splitRadioGroupProps = createSplitProps(radioGroupProps);
const radioItemProps = createProps()([
  "aria-describedby",
  "data-radiogroup",
  "defaultChecked",
  "id",
  "isChecked",
  "isDisabled",
  "isFocusable",
  "isInvalid",
  "isReadOnly",
  "isRequired",
  "name",
  "onChange",
  "value"
]);
const splitRadioItemProps = createSplitProps(radioItemProps);

export { splitRadioGroupProps, splitRadioItemProps };
